module.exports = math;


//////////////////
// WEBPACK FOOTER
// external "math"
// module id = 447
// module chunks = 0